import { ChevronLeft, ChevronRight } from 'lucide-react'

import { Button } from '@/shared/components/atoms/Button'
import { cn } from '@/shared/utils/helpers'

interface ModalPaginatorProps {
	currentPage: number
	totalPages: number
	onPageChange: (page: number) => void
	className?: string
}

export function ModalPaginator({
	currentPage,
	totalPages,
	onPageChange,
	className,
}: ModalPaginatorProps) {
	if (totalPages <= 1) {
		return null
	}

	return (
		<div className={cn('flex items-center justify-between pt-2', className)}>
			<span className="text-xs text-muted-foreground">
				{currentPage} / {totalPages}
			</span>
			<div className="flex items-center gap-1">
				<Button
					type="button"
					variant="ghost"
					size="icon"
					className="h-7 w-7"
					onClick={() => onPageChange(currentPage - 1)}
					disabled={currentPage === 1}
					aria-label="Previous page"
				>
					<ChevronLeft className="h-4 w-4" />
				</Button>
				<Button
					type="button"
					variant="ghost"
					size="icon"
					className="h-7 w-7"
					onClick={() => onPageChange(currentPage + 1)}
					disabled={currentPage >= totalPages}
					aria-label="Next page"
				>
					<ChevronRight className="h-4 w-4" />
				</Button>
			</div>
		</div>
	)
}
